import React from "react";
import MedTagWalletCard from "../components/MedTagWallet";

export default function WalletCardPreview() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FFF8]">
      <MedTagWalletCard patientName="Patient" />
    </div>
  );
}
